// Barrel export for all task template types and data

// Types
export type { TaskTemplate, TaskTemplateCategory } from "./types";

// Template categories
export { MSP_ONBOARDING_TEMPLATES } from "./onboarding-templates";
export { MSP_SALES_TEMPLATES } from "./sales-templates";
export { MSP_SUPPORT_TEMPLATES } from "./support-templates";
export { MSP_OPERATIONS_TEMPLATES } from "./operations-templates";
export { MSP_SCHOLEY_MITCHELL_TEMPLATES } from "./schooley-mitchell-templates";
export { MSP_WEST_TENNESSEE_CONSULTING_TEMPLATES } from "./west-tennessee-consulting-templates";

// Template tags
export { TEMPLATE_TAG_SETS } from "./template-tags";

// Combined templates array (for backward compatibility)
import { MSP_ONBOARDING_TEMPLATES } from "./onboarding-templates";
import { MSP_SALES_TEMPLATES } from "./sales-templates";
import { MSP_SUPPORT_TEMPLATES } from "./support-templates";
import { MSP_OPERATIONS_TEMPLATES } from "./operations-templates";
import { MSP_SCHOLEY_MITCHELL_TEMPLATES } from "./schooley-mitchell-templates";
import { MSP_WEST_TENNESSEE_CONSULTING_TEMPLATES } from "./west-tennessee-consulting-templates";
import type { TaskTemplateCategory } from "./types";

export const MSP_TASK_TEMPLATES: TaskTemplateCategory[] = [
  MSP_ONBOARDING_TEMPLATES,
  MSP_SALES_TEMPLATES,
  MSP_SUPPORT_TEMPLATES,
  MSP_OPERATIONS_TEMPLATES,
  MSP_SCHOLEY_MITCHELL_TEMPLATES,
  MSP_WEST_TENNESSEE_CONSULTING_TEMPLATES,
];
